/**
* Video Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Video Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'video-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.video-slider' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--video-slider' )[0], {
          type: 'loop',
          pagination: false,
          arrows: true,
          gap: '32px',
          autoWidth: true,
          direction: window.isRtl ? 'rtl' : 'ltr',
          breakpoints: {
            640: {
              perPage: 1,
              autoWidth: false,
            },
          },
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'video-slider', COMPONENT );
} )( app );
